/*********************************************************************** 
Documentations = https://github.com/azouaoui-med/pro-sidebar-template
************************************************************************/
import $ from 'jquery';
import React, {useEffect, useState} from 'react';
import {withTranslation} from 'react-i18next';
import i18n from '../../i18n';
import {Menu, MenuItem, ProSidebar, SidebarContent, SidebarFooter, SidebarHeader} from 'react-pro-sidebar';
import {Link} from 'react-router-dom';
import MenuItemIcon from '../MenuItemIcon';
import ActionButton from '../ActionButton';
import I18nUtils from '../utils/I18nUtils';
import DivContainer from '../DivContainer';
import BlockUi from '../waitPanel/BlockUi';
import {ActionLink} from '../ActionLink';
import NumberFormat from 'react-number-format';
import moment from 'moment';
import InputAutocompleteComponent from '../inputs/InputAutocompleteComponent';
import {FaCar} from 'react-icons/fa';

const Sidebar = ({
    t,
    collapsed,
    toggled,
    loggedUser,
    handleToggleSidebar,
    handleCollapsedChange,
    handleLogoutUser,
    authService,
    accountService,
    userService,
    submenu,
    activeUrl,
    allCbk,
    handleChangeCbk
}) => {
    // const userName = authService.getProfile().sub;
    // const role = authService.getProfile().role;
    const [showMenu, changeShowMenu] = useState(false);
    const [showFuntionsMenu, changeShowFunctionsMenu] = useState(false);
    const [showAgreements, changeShowAgreements] = useState(false);
    const [showLanguages, changeShowLanguages] = useState(false);
    const [spotPriceList, setSpotPriceList] = useState(false);
    const [spotPriceListLoading, setSpotPriceListLoading] = useState(false);
    const [spotPriceListError, setSpotPriceListError] = useState(false);
    const [stateActiveUrl] = useState();
    const [cbkNumber, setCbkNumber] = useState(null);
    const [filteredCbkNumbers, setFilteredCbkNumbers] = useState(null);
    const [allCbkSidebar, setAllCbkSidebar] = useState(null);


    useEffect(() => {
        if (activeUrl !== stateActiveUrl) {
            $('.pro-menu-item:not(.spot-price-list) .pro-inner-item').each(function (index) {
                $(this).removeClass('active');
            });
            $(document.getElementsByClassName(`pro-menu-item ${activeUrl}`))
                .children('div')
                .addClass('active')
                .siblings()
                .removeClass('active');
        }
    }, [activeUrl, stateActiveUrl]);

    useEffect(() => {
        async function refreshSpotPriceList() {
            if (authService.loggedIn() && authService.showSpotPrices()) {
                setSpotPriceListLoading(true);
                accountService
                    .getSpotPriceList()
                    .then((res) => {
                        setSpotPriceList(res);
                        setSpotPriceListLoading(false);
                        setSpotPriceListError(false);
                    })
                    .catch(() => {
                        setSpotPriceList(false);
                        setSpotPriceListLoading(false);
                        setSpotPriceListError(true);
                    });
            }
        }
        if (!spotPriceList && !spotPriceListLoading) {
            if (spotPriceListError) {
                setTimeout(() => {
                    refreshSpotPriceList();
                }, 5000);
            } else {
                refreshSpotPriceList();
            }
        }
    });

   
    function getAllCbk(){
        let hdUsers = null;
        accountService
            .getHelpDeskUsers()
            .then((helpDeskUsers) =>
            {setAllCbkSidebar(helpDeskUsers)
            hdUsers = helpDeskUsers;
        })
        .catch(() => {
        });
            return hdUsers;
    }
    function filterCbk(query){
        let filteredHelpdeskUsers = [];
        let cbInSidebar = allCbkSidebar;
        if(cbInSidebar === null || cbInSidebar === undefined || cbInSidebar.length === 0){
            filteredHelpdeskUsers = [];
        }
        else if (query && query !== '' && cbInSidebar !== undefined && cbInSidebar.length > 0) {
            cbInSidebar.forEach((el) => {
                if (el.caption.toLowerCase().includes(query.toLowerCase())) {
                    filteredHelpdeskUsers.push(el);
                }
            });
        } 
        setFilteredCbkNumbers(filteredHelpdeskUsers);
    }

    function refreshSpotPriceList() {
        if (authService.loggedIn && authService.getPermissions().length > 0) {
            setSpotPriceListLoading(true);
            accountService
                .getSpotPriceList()
                .then((res) => {
                    setSpotPriceList(res);
                    setSpotPriceListLoading(false);
                    setSpotPriceListError(false);
                })
                .catch(() => {
                    setSpotPriceList(false);
                    setSpotPriceListLoading(false);
                    setSpotPriceListError(true);
                });
        }
    }

    function changeLanguage(language) {
        if (userService !== null) {
            userService.changeLanguage(language).then(() => {
                sessionStorage.setItem('i18nextLng', language);
                i18n.changeLanguage(language);
            });
        }
    }

    function changeRoleType(sapRoleId) {
        if (userService !== null && authService !== null) {
            userService.changeRoleType(sapRoleId).then((res) => {
                authService.setToken(res.token);
                window.location.href = '/#start';
                window.location.reload();
            });
        }
    }

    function renderOverlay() {
        return (
            <div
                className='show-menu-overlay'
                onClick={(e) => {
                    e.preventDefault();
                    if (showMenu || showFuntionsMenu) {
                        changeShowMenu(false);
                        changeShowFunctionsMenu(false);
                        changeShowLanguages(false);
                        changeShowAgreements(false);
                    }
                }}
            />
        );
    }

    function loader() {
        let label = 'Operacja w toku, proszę czekać.';
        return (
            <div id='cover-spin-container'>
                <div id='cover-spin' />
                <div id='cover-spin-text'>
                    <p>{label}</p>
                </div>
            </div>
        );
    }


    //rounding error won’t happen if you represent your numbers exponentially
    function round(value, decimals) {
        //Number(Math.round(value+'e'+decimals)+'e-'+decimals);
        return Number(value.toExponential(decimals));
      }

    function renderHorizontalSidebar() {
        return !authService.loggedIn() && !submenu ? null : (
            <div style={{width: '100%'}}>
                <div className='sidebar-horizontal-content'>
                    <ActionButton
                        label={t('sidebar.sidebarMenuButton')}
                        variant={showMenu ? 'sidebar-button menu-close' : 'sidebar-button menu'}
                        handleClick={(e) => {
                            e.preventDefault();
                            changeShowMenu(!showMenu);
                            changeShowFunctionsMenu(false);
                            changeShowLanguages(false);
                            changeShowAgreements(false);                        
                        }}
                        iconSvg={showMenu ? 'ico-sidebar-close' : 'ico_sidebar_menu'}
                        iconSide='left'
                        iconSize={showMenu ? 'menu-close' : 'menu'}
                        rendered = {(authService.getProfile().helpdeskUserRole !== 'BANK_BPS' &&  authService.getProfile().helpdeskUserRole !== 'BANK_SGB')}
                    />
                    <img className='sidebar-header-logo' alt='logo MOYA' src='/images/header_moya.svg' />
                    <ActionButton
                        label={''}
                        variant={'sidebar-button profile'}
                        handleClick={(e) => {
                            e.preventDefault();
                            changeShowFunctionsMenu(!showFuntionsMenu);
                            changeShowMenu(false);
                            changeShowLanguages(false);
                            changeShowAgreements(false);
                            if(allCbkSidebar === null || allCbkSidebar.length === 0){
                                getAllCbk();
                            }
                        }}
                        iconSvg='ico_sidebar_functions'
                        iconSide='left'
                        iconSize='profile'
                        rendered = {(authService.getProfile().helpdeskUserRole !== 'BANK_BPS' &&  authService.getProfile().helpdeskUserRole !== 'BANK_SGB')}
                    />
                    {(authService.getProfile().helpdeskUserRole === 'BANK_BPS' ||  authService.getProfile().helpdeskUserRole === 'BANK_SGB') ? 
                    <div onClick={() =>  handleLogoutUser()} className='header-link' rel='noopener noreferrer'>
                                    <span className='logout-bank'>{t('header.logout')}</span>
                                </div>  : null}
                </div>
                <div className={`sidebar ${showMenu ? 'show-menu' : ''}`}>{renderVerticalSidebar()}</div>
                <div className={`sidebar functions-menu ${showFuntionsMenu ? 'show-menu' : ''}`}>{renderFunctionsSidebar()}</div>
            </div>
        );
    }

    function renderVerticalSidebar() {
        return !authService.loggedIn() || (authService.getProfile().helpdeskUserRole === 'BANK_BPS' || 
        authService.getProfile().helpdeskUserRole === 'BANK_SGB') ? null : (
            <React.Fragment>
                <div className={`pro-sidebar-background ${showMenu ? 'show-menu' : ''}`} />
                {renderOverlay()}
                <ProSidebar collapsed={collapsed} toggled={toggled} onToggle={handleToggleSidebar} className='pro-sidebar-layout'>
                    {submenu ? null : (
                        <SidebarHeader>
                            <span className='sidebar-version'>
                                wersja: {process.env.REACT_APP_VERSION} ({process.env.REACT_APP_BUILD_NUMBER})
                            </span>
                            <div className='sidebar-header-logo-div'>
                                <img className='sidebar-header-logo' alt='logo MOYA' src='/images/header_moya.svg' />
                            </div>
                        </SidebarHeader>
                    )}
                    <SidebarContent>
                        <Menu>
                            <MenuItem className='start' icon={<MenuItemIcon alt='Start' iconSvg='ico_menu_start' />}>
                                <div
                                    onClick={(e) => {
                                        e.preventDefault();
                                        changeShowMenu(false);
                                    }}
                                >
                                    {t('sidebar.start')}
                                    <Link to='/start' />
                                </div>
                            </MenuItem>
                            {((authService.isUserInRole('ROLE_FLEET') && authService.isUserHasPermission('PERMISSION_FULL_ACCESS_STATIONS_MAP'))
                                || authService.isUserInAnyRole('ROLE_WHOLESALE', 'ROLE_FRANCHISE', 'ROLE_ESPPOL', 'ROLE_DRIVER')) &&
                                !(authService.getProfile().helpdeskUserRole === 'REGIONAL_MANAGER' || 
                                authService.getProfile().helpdeskUserRole === 'SALES_REPRESENTATIVE') ? (
                                <MenuItem className='map' icon={<MenuItemIcon alt='Mapa stacji' iconSvg='ico_menu_map' />}>
                                    <div
                                        onClick={(e) => {
                                            e.preventDefault();
                                            changeShowMenu(false);
                                        }}
                                    >
                                        {t('sidebar.stationsMap')}
                                        <Link to='/map' />
                                    </div>
                                </MenuItem>
                            ) : null}
                            {authService.isUserInRole('ROLE_FLEET') && authService.isUserHasAnyPermission('PERMISSION_VIEW_FLEET_CARDS', 'PERMISSION_EDIT_FLEET_CARDS') ? (
                                <MenuItem className='cards' icon={<MenuItemIcon alt='Karty flotowe' iconSvg='ico_menu_card' />}>
                                    <div
                                        onClick={(e) => {
                                            e.preventDefault();
                                            changeShowMenu(false);
                                        }}
                                    >
                                        {t('sidebar.fleetCards')}
                                        <Link to='/cards' />
                                    </div>
                                </MenuItem>
                            ) : null}
                            {authService.isUserInAnyRole('ROLE_WHOLESALE', 'ROLE_FRANCHISE', 'ROLE_ESPPOL') ? (
                                <MenuItem className='orders' icon={<MenuItemIcon alt='Zamówienia' iconSvg='ico_menu_orders' />}>
                                    <div
                                        onClick={(e) => {
                                            e.preventDefault();
                                            changeShowMenu(false);
                                        }}
                                    >
                                        {t('sidebar.orders')}
                                        <Link to='/orders' />
                                    </div>
                                </MenuItem>
                            ) : null}
                            {authService.isUserInRole('ROLE_FLEET') && authService.isUserHasPermission('PERMISSION_FULL_ACCESS_ORDERS') ? (
                                <MenuItem className='card-order-list' icon={<MenuItemIcon alt='Zamówienia' iconSvg='ico_menu_basket' />}>
                                    <div
                                        onClick={(e) => {
                                            e.preventDefault();
                                            changeShowMenu(false);
                                        }}
                                    >
                                        {t('sidebar.orders')}
                                        <Link to='/card-order-list' />
                                    </div>
                                </MenuItem>
                            ) : null}
                            {((authService.isUserInRole('ROLE_FLEET') && authService.isUserHasAnyPermission('PERMISSION_VIEW_INVOICES', 'PERMISSION_EDIT_INVOICES'))
                                || authService.isUserInAnyRole('ROLE_WHOLESALE', 'ROLE_FRANCHISE', 'ROLE_ESPPOL')) ? (
                                <MenuItem className='invoice-list' icon={<MenuItemIcon alt='Faktury' iconSvg='ico_menu_invoice' />}>
                                    <div
                                        onClick={(e) => {
                                            e.preventDefault();
                                            changeShowMenu(false);
                                        }}
                                    >
                                        {t('sidebar.invoices')}
                                        <Link to='/invoice-list' />
                                    </div>
                                </MenuItem>
                            ) : null}
                            {authService.isUserInRole('ROLE_FLEET') && authService.isUserHasAnyPermission('PERMISSION_VIEW_TRANSACTIONS', 'PERMISSION_EDIT_TRANSACTIONS') ? (
                                <MenuItem className='transaction-list' icon={<MenuItemIcon alt='Transakcje' iconSvg='ico_menu_transaction' />}>
                                    <div
                                        onClick={(e) => {
                                            e.preventDefault();
                                            changeShowMenu(false);
                                        }}
                                    >
                                        {t('sidebar.transactions')}
                                        <Link to='/transaction-list' />
                                    </div>
                                </MenuItem>
                            ) : null}
                            {/* {authService.isUserInAnyRole('ROLE_FLEET') ? (
                                <MenuItem className='mobile' icon={<MenuItemIcon alt='Start' iconSvg='ico_menu_mobile' />}>
                                    {t('sidebar.mobileApp')}
                                    <Link to='/mobile' />
                                </MenuItem>
                            ) : null} */}
                            {authService.isUserInAnyRole('ROLE_WHOLESALE', 'ROLE_FRANCHISE', 'ROLE_ESPPOL') &&
                                !(authService.getProfile().helpdeskUserRole === 'REGIONAL_MANAGER' || 
                                authService.getProfile().helpdeskUserRole === 'SALES_REPRESENTATIVE') ? (
                                <MenuItem className='drivers-list' icon={<MenuItemIcon alt='Kierowcy i pojazdy' iconSvg='ico_car' />}>
                                    <div
                                        onClick={(e) => {
                                            e.preventDefault();
                                            changeShowMenu(false);
                                        }}
                                    >
                                        {t('sidebar.driversAndVehicles')}
                                        <Link to='/drivers-list' />
                                    </div>
                                </MenuItem>
                            ) : null}
                            {authService.isUserInRole('ROLE_FLEET') && authService.isUserHasAnyPermission('PERMISSION_VIEW_REPORTS', 'PERMISSION_EDIT_REPORTS') ? (
                                <MenuItem className='reports' icon={<MenuItemIcon alt='Raporty' iconSvg='ico_menu_reports' />}>
                                    <div
                                        onClick={(e) => {
                                            e.preventDefault();
                                            changeShowMenu(false);
                                        }}
                                    >
                                        {t('sidebar.reports')}
                                        <Link to='/reports' />
                                    </div>
                                </MenuItem>
                            ) : null}
                            {((authService.isUserInRole('ROLE_FLEET') && authService.isUserHasAnyPermission('PERMISSION_VIEW_PROFILE', 'PERMISSION_EDIT_PROFILE'))
                                || authService.isUserInAnyRole('ROLE_WHOLESALE', 'ROLE_FRANCHISE', 'ROLE_ESPPOL')) ? (
                                <MenuItem className='profile' icon={<MenuItemIcon alt='Profil' iconSvg='ico_menu_profile' />}>
                                    <div
                                        onClick={(e) => {
                                            e.preventDefault();
                                            changeShowMenu(false);
                                        }}
                                    >
                                        {t('sidebar.profile')}
                                        <Link to='/profile' />
                                    </div>
                                </MenuItem>
                            ) : null}
                                {authService.isUserInRole('ROLE_FLEET') &&  authService.getProfile().agreementType === 'CASHLESS' && authService.isUserHasAnyPermission('PERMISSION_FULL_ACCESS_ADDITIONAL_SERVICES') ? (
                                <MenuItem className='additional-services' icon={<FaCar />}>
                                <div
                                    onClick={(e) => {
                                        e.preventDefault();
                                        changeShowMenu(false);
                                    }}
                                >
                                    {t('sidebar.additionalServices')}
                                    <Link to='/additional-services' />
                                </div>

                            </MenuItem>
                               
                            ) : null}
                            {authService.isUserInRole('ROLE_FLEET') && authService.isUserHasAnyPermission('PERMISSION_VIEW_SETTINGS', 'PERMISSION_EDIT_SETTINGS') ? (
                                <MenuItem className='settings' icon={<MenuItemIcon alt='Ustawienia' iconSvg='ico_menu_settings' />}>
                                    <div
                                        onClick={(e) => {
                                            e.preventDefault();
                                            changeShowMenu(false);
                                        }}
                                    >
                                        {t('sidebar.settings')}
                                        <Link to='/settings' />
                                    </div>
                                </MenuItem>
                            ) : null}
                          
                        </Menu>
                        <DivContainer colClass='spot-price-list-container pro-menu'>
                            <ul>
                                <MenuItem className='spot-price-list' icon={<MenuItemIcon alt='Start' iconSvg='ico_menu_orders' />}>
                                    <div>{t('sidebar.spotPriceList.title')}</div>
                                    {!spotPriceListLoading && spotPriceList.spotDate !== undefined && spotPriceList.spotDate !== null ? (
                                        <div>{`${t('sidebar.spotPriceList.spotDate')} ${moment(spotPriceList.spotDate).format(
                                            'DD-MM-YYYY'
                                        )}`}</div>
                                    ) : null}
                                </MenuItem>
                            </ul>
                            <BlockUi
                                tag='div'
                                blocking={spotPriceListLoading}
                                loader={loader}
                                loaderType='small-loader spot-loader'
                                horizontal
                            >
                                <DivContainer colClass='spot-price-list-content'>
                                    {spotPriceListError ? (
                                        <ActionLink
                                            // label={`${t('cards.orderPlasticCard')} ${
                                            //     this.state.orderPlasticCardPrice
                                            // } ${t('currency.pln')}`}
                                            label={`${t('cards.orderPlasticCard')}`}
                                            handleClick={() => refreshSpotPriceList()}
                                            variant='blue'
                                            // iconSize='icon-svg'
                                            className='edit-blue-link under-table-button-left-icon'
                                            key={'view-button'}
                                            iconSide='left'
                                            iconSvg='ico_blue_plus'
                                        />
                                    ) : (
                                        <DivContainer colClass='spot-price-list' key='spot-price-list'>
                                            {spotPriceList && spotPriceList.content
                                                ? spotPriceList.content.map((spl, index) => {
                                                      const priceValue = (authService.getProfile().agreementSapRole === 'HURT' ||
                                                      authService.getProfile().agreementSapRole === 'FRANCZYZA' ||
                                                      authService.getProfile().agreementSapRole === 'HURT EPT') ? spl.price : round(spl.price, 2);
                                                      const color = spl.color ? spl.color : 'white';
                                                      const fontColor = spl.color ? 'white' : '#090E22';
                                                      return (
                                                          <DivContainer colClass='spot-price-element' key={`spot-price-element-${index}`}>
                                                              <label
                                                                  key={`spot-price-element-${spl.name}-${index}`}
                                                                  className='spot-price-element-label'
                                                                  style={{backgroundColor: `${color}`, color: `${fontColor}`}}
                                                              >
                                                                  {t(`products.${spl.name}`)}
                                                              </label>
                                                              <span className='spot-price-element-price'>
                                                                  <NumberFormat
                                                                      value={priceValue}
                                                                      displayType={'text'}
                                                                      thousandSeparator=' '
                                                                      decimalSeparator=','
                                                                      fixedDecimalScale
                                                                      decimalScale={2}
                                                                      suffix={` ${t('currency.pln')}`}
                                                                      renderText={(value) => value}
                                                                  />
                                                              </span>
                                                          </DivContainer>
                                                      );
                                                  })
                                                : null}
                                        </DivContainer>
                                    )}
                                </DivContainer>
                            </BlockUi>
                        </DivContainer>
                    </SidebarContent>
                </ProSidebar>
            </React.Fragment>
        );
    }

    function renderFunctionsSidebar() {
        const supportedLanguages = I18nUtils.getSupportedLanguages(3);
        const languages = [];
        supportedLanguages.forEach((l) => {
            languages.push({value: l, label: t(`header.${l}`)});
        });
        return !authService.loggedIn() ? null : (
            <React.Fragment>
                {renderOverlay()}
                <ProSidebar
                    collapsed={collapsed}
                    toggled={toggled}
                    onToggle={handleToggleSidebar}
                    className='pro-sidebar-layout functions-menu'
                >
                    <SidebarContent>
                        <Menu>
                            {authService.getProfile().sapRoleIdsList?.length > 1 && (authService.getProfile().helpdeskUserRole !== 'BANK_BPS' &&  authService.getProfile().helpdeskUserRole !== 'BANK_SGB')? (
                                <MenuItem key='agreement' className='sidebar-submenu'>
                                    <div
                                        onClick={(e) => {
                                            e.preventDefault();
                                            changeShowAgreements(!showAgreements);
                                            changeShowLanguages(false);
                                        }}
                                    >
                                        {t('header.agreement')}
                                    </div>
                                    <Menu key='agreement-items' className={`sidebar-submenu-items ${showAgreements ? 'show' : ''}`}>
                                        {authService.getProfile().sapRoleIdsList.map((el) => {
                                            return (
                                                <MenuItem key={`agreement-${el}`} className='agreement-item'>
                                                    <div
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            changeShowAgreements(false);
                                                            changeShowFunctionsMenu(false);
                                                            if (el !== authService.getProfile().agreementSapRoleId) {
                                                                changeRoleType(el);
                                                            }
                                                        }}
                                                    >
                                                        {t(`header.${el}`)}
                                                    </div>
                                                </MenuItem>
                                            );
                                        })}
                                    </Menu>
                                </MenuItem>
                            ) : null}
                            {languages.length > 1 ? (
                                <MenuItem key='language' className='sidebar-submenu'>
                                    <div
                                        onClick={(e) => {
                                            e.preventDefault();
                                            changeShowLanguages(!showLanguages);
                                            changeShowAgreements(false);
                                        }}
                                    >
                                        {t('header.language')}
                                    </div>
                                    <Menu key='language-items' className={`sidebar-submenu-items ${showLanguages ? 'show' : ''}`}>
                                        {languages.map((el) => {
                                            return (
                                                <MenuItem key={`language-${el}`} className='language-item'>
                                                    <div
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            changeShowLanguages(false);
                                                            changeShowFunctionsMenu(false);
                                                            if (el.value !== sessionStorage.getItem('i18nextLng')) {
                                                                changeLanguage(el.value);
                                                            }
                                                        }}
                                                    >
                                                        {el.label}
                                                    </div>
                                                </MenuItem>
                                            );
                                        })}
                                    </Menu>
                                </MenuItem>
                            ) : null}
                            <MenuItem className='contact'>
                                <div
                                    onClick={(e) => {
                                        e.preventDefault();
                                        changeShowFunctionsMenu(!showFuntionsMenu);
                                        changeShowLanguages(false);
                                        changeShowAgreements(false);
                                    }}
                                >
                                    {t('header.contact')}
                                    <Link to='/contact' />
                                </div>
                            </MenuItem>
                            {/* <MenuItem className='faq'>
                                <div
                                    onClick={(e) => {
                                        e.preventDefault();
                                        changeShowFunctionsMenu(!showFuntionsMenu);
                                        changeShowLanguages(false);
                                        changeShowAgreements(false);
                                    }}
                                >
                                    {t('header.faq')}
                                    <Link to='/faq' />
                                </div>
                            </MenuItem> */}
                            <MenuItem className='drivers-list'>
                                <div
                                    onClick={(e) => {
                                        e.preventDefault();
                                        changeShowFunctionsMenu(!showFuntionsMenu);
                                        changeShowLanguages(false);
                                        changeShowAgreements(false);
                                        handleLogoutUser();
                                    }}
                                    className='header-link'
                                    rel='noopener noreferrer'
                                >
                                    <span>{t('header.logout')}</span>
                                </div>
                            </MenuItem>

                            {authService.getProfile().helpDeskUser &&
                                (authService.getProfile().helpdeskUserRole === 'HELPDESK' || 
                                    authService.getProfile().helpdeskUserRole === 'REGIONAL_MANAGER' || 
                                    authService.getProfile().helpdeskUserRole === 'SALES_REPRESENTATIVE' || 
                                    authService.getProfile().helpdeskUserRole === 'HOTLINE'
                                ) ? 
                            <MenuItem className='contrahent'>
                                <span>Kontrahent</span>
                                 <div className='col-12 sidebar-contractor'>
                                    
                                <InputAutocompleteComponent
                                id='helpdeskUser'
                                name='helpdeskUser'
                                label={t('login.helpdeskDialog.helpdeskUser')}
                                colClass='col-8 header-contractor-autocomplete'
                                panelClassName='hd-auto-complete-panel'
                                value={cbkNumber}
                                showLabel ={false}
                                viewMode='EDIT'
                               
                                stateField=''
                               onChange={(a,b,c,d,e) => {
                                
                                if (c.value !== undefined && c.value !== null) { 
                                    setCbkNumber(c.value.cbkId)
                                }
                            }}
                                rendered={true}
                                filterList={(query) => {
                                    filterCbk(query);
                                }}
                                filteredList={filteredCbkNumbers}
                                dropdown
                                field='caption'
                                forceSelection
                                minLengthQuery={3}
                                minLength={3}
                                placeholder={"Kontrahent"}
                            />
                           
                            </div>
                            <ActionButton
                                    label={'Zmień'}
                                    className='sidebar-contractor-button'
                                    handleClick={() =>               
                                        cbkNumber !== null ?
                                        handleChangeCbk(cbkNumber) : null
                                        }
                                    disabled={cbkNumber === null}
                                />
                            
                            </MenuItem>
                            
                            
                            
                            : null
                        }

                        </Menu>
                    </SidebarContent>
                    <SidebarFooter>
                        <span className='sidebar-version'>
                            wersja: {process.env.REACT_APP_VERSION} ({process.env.REACT_APP_BUILD_NUMBER})
                        </span>
                    </SidebarFooter>
                </ProSidebar>
            </React.Fragment>
        );
    }

    function render() {
        return submenu ? renderHorizontalSidebar() : renderVerticalSidebar();
    }
    return render();
};

export default withTranslation()(Sidebar);
